import { api } from '../client';

export interface Patch {
  _id: string;
  name: string;
  description?: string;
  script: string;
  target: string;
  active: boolean;
  applied_count: number;
  total_target: number;
  created_at: string;
}

export const settingsApi = {
  getVendorPortal: () =>
    api.get<{ enabled: boolean }>('/api/settings/vendor-portal'),

  toggleVendorPortal: (enabled: boolean) =>
    api.put<{ success: boolean; enabled: boolean }>('/api/settings/vendor-portal', { enabled }),

  getDeploymentSecret: () =>
    api.get<{ success: boolean; length: number; configured: boolean }>('/api/settings/deployment-secret'),

  health: () =>
    api.get<{ status: string; uptime: number }>('/api/health'),

  // Remote Scripts (Patches)
  listPatches: () =>
    api.get<{ success: boolean; patches: Patch[] }>('/api/patches'),

  deployPatch: (data: { name: string; description: string; script: string; target: string }) =>
    api.post<{ success: boolean }>('/api/patches', data),

  deactivatePatch: (name: string) =>
    api.delete<{ success: boolean }>(`/api/patches/${encodeURIComponent(name)}`),

  patchLogs: (params: { patch_name?: string; client_id?: string; page?: number; limit?: number }) =>
    api.get<{ success: boolean; logs: Array<{ patch_name: string; client_id: string; client_name: string; status: string; output: string; exit_code: number | null; applied_at: string }>; total: number }>(
      '/api/patch-logs', params
    ),

  searchClients: (q: string, filters?: { name?: string; subdomain?: string; deployment?: string }) =>
    api.get<{ success: boolean; clients: Array<{ client_id: string; client_name: string; deployment_name?: string; subdomain?: string; status: string }> }>(
      '/api/clients-search', { q, limit: 2000, ...filters }
    ),
};
